//Imports node_moduleso messa
import React, { useContext, useEffect } from 'react'
import { CSSTransition } from 'react-transition-group';
import Modal from 'react-modal';
import { useNavigate } from 'react-router-dom';
import Cookies from 'universal-cookie';

//Imports Css
import './MessageModal.css'

//Imports Components

//Import Data
import { globalModals } from '../../../../data/GlobalModals'
import { globalVariables } from '../../../../data/GlobalVariables';
import { globalFunctions } from '../../../../data/GlobalFunctions';
import ButtonAdvanced from '../../buttonAdvanced/ButtonAdvanced';


//Layout de navegação na parte inferior da aplicação
const MessageModal = (params) => {

    Modal.setAppElement('body');
    const cookies = new Cookies();
    const {
        messageModalStatus,
        modalInfo,
        DismisMessageModal,
    } = useContext(globalModals)

    const {
        ResetAll,
    } = useContext(globalVariables)

    const {
        advancedClick
    } = useContext(globalFunctions);


    const navigate = useNavigate();


    //Estilos para o header
    let classesHeader = 'modal-header '
    switch (modalInfo.modaltype) {
        case 'info': classesHeader += 'info';
            break;
        case 'success': classesHeader += 'success';
            break;
        case 'caution': classesHeader += 'caution';
            break;
        case 'warning': classesHeader += 'warning';
            break;
        case 'error': classesHeader += 'error';
            break;
        case 'message':
            break;
        default:
            break;
    }

    let classesButtonNext = 'modalBtn '
    switch (modalInfo.modaltype) {
        case 'info': classesButtonNext += 'info';
            break;
        case 'success': classesButtonNext += 'success';
            break;
        case 'caution': classesButtonNext += 'caution';
            break;
        case 'warning': classesButtonNext += 'warning';
            break;
        case 'error': classesButtonNext += 'error';
            break;
        case 'message': classesButtonNext += 'message';
            break;
        default:
            break;
    }

    let iconClasse = '';

    switch (modalInfo.modaltype) {
        case 'info': iconClasse += '';
            break;
        case 'success': iconClasse += 'fa fa-check';
            break;
        case 'caution': iconClasse += 'fa fa-exclamation-circle';
            break;
        case 'warning': iconClasse += 'fa fa-exclamation-triangle';
            break;
        case 'error': iconClasse += 'fa fa-chain-broken';
            break;
        case 'message':
            break;
        default:
            break;
    }

    function reset() {
        var date = new Date();
        date.setTime(date.getTime() + (999 * 24 * 60 * 60 * 1000));
        var emptyObject = []
        localStorage.setItem('storedGroupMembers', JSON.stringify(emptyObject));

        ResetAll(); 
        DismisMessageModal(); 
        navigate('/userPage');
    }

    function renderBackButton() {
        if (modalInfo.backClick) {
            if (modalInfo.backClick === 'dismiss') {
                return (
                    <ButtonAdvanced
                        type="button"
                        className='modalBtn modalBtn-light'
                        onClick={e => DismisMessageModal()}
                        text={modalInfo.backBtnTxt ? modalInfo.backBtnTxt : 'Fechar'}>
                    </ButtonAdvanced>
                )
            } else {
                return (
                    <ButtonAdvanced
                        type="button"
                        className='modalBtn modalBtn-light'
                        onClick={e => modalInfo.backClick()}
                        style={modalInfo.specialButons ? { backgroundColor: '#f6f6f6', borderColor: '#04568E', color: '#333333', marginRight: '30px'} : {}}
                        text={modalInfo.backBtnTxt ? modalInfo.backBtnTxt : 'Fechar'}>
                    </ButtonAdvanced>
                )
            }
        }
    }

    function renderExtraBtn() {
        if (modalInfo.extraClick) {
            return (
                <ButtonAdvanced
                    type="button"
                    className={classesButtonNext}
                    onClick={e => modalInfo.nextClick()}
                    text={modalInfo.nextBtnTxt ? modalInfo.nextBtnTxt : 'Ok'}>
                </ButtonAdvanced>
            )
        }
    }

    function renderNextBtn() {
        if (modalInfo.nextClick) {
            if (modalInfo.nextClick === 'dismiss') {
                return (
                    <ButtonAdvanced
                        type="button"
                        className={classesButtonNext}
                        onClick={e => DismisMessageModal()}
                        text={modalInfo.nextBtnTxt ? modalInfo.nextBtnTxt : 'Ok'}>
                    </ButtonAdvanced>
                )
            } else {

                if (modalInfo.nextClick === 'reset') {
                    return (
                        <ButtonAdvanced
                            type="button"
                            className={classesButtonNext}
                            onClick={e => reset()}
                            text={modalInfo.nextBtnTxt ? modalInfo.nextBtnTxt : 'Ok'}>
                        </ButtonAdvanced>
                    )
                } else {
                    return (
                        <ButtonAdvanced
                            style={params.specialButons? {}: {}}
                            type="button"
                            className={classesButtonNext}
                            onClick={e => modalInfo.nextClick()}
                            text={modalInfo.nextBtnTxt ? modalInfo.nextBtnTxt : 'Ok'}>
                        </ButtonAdvanced>
                    )
                }


            }
        }
    }



    function renderCrossBtn() {
        if (modalInfo.crossClick) {
            if (modalInfo.crossClick === 'dismiss') {
                return (
                    <ButtonAdvanced
                        type="button"
                        className="btn-small-close"
                        onClick={e => DismisMessageModal()}>
                        <ion-icon style={{ padding: '0px', fontSize: '30px' }} name="close-outline">
                        </ion-icon>
                    </ButtonAdvanced>
                )
            } else {
                return (
                    <ButtonAdvanced
                        type="button"
                        className="btn-small-close"
                        onClick={e => modalInfo.crossClick()}>
                        <ion-icon style={{ padding: '0px', fontSize: '30px' }} name="close-outline">
                        </ion-icon>
                    </ButtonAdvanced>
                )
            }
        }
    }



    function renderContent() {
        return (
            <div className="modal-dialog modal-dialog-centered" role="document" style={modalInfo.hidden ? { visibility: 'hidden' } : {}}>
                <div className="modal-content">
                    <div className={classesHeader}>
                        <h4 className="modal-title" id="staticBackdropLabel">
                            <i className={iconClasse} aria-hidden="true" style={{ marginRight: '10px', fontSize: '20px', padding: '0px' }}></i>{modalInfo.modalTitle}
                        </h4>
                        {renderCrossBtn()}
                    </div>
                    <div className="modal-body" style={{ whiteSpace: 'preWrap' }}>
                        <h4>Mensagem:</h4>
                        <p>{modalInfo.modalMessage} </p>
                    </div>

                    <div className="modal-footer">
                        {renderBackButton()}
                        {renderExtraBtn()}
                        {renderNextBtn()}
                    </div>
                </div>
            </div>
        )
    }

    return (
        <div>
            <CSSTransition
                in={messageModalStatus}
                timeout={300}
                classNames="dialog">
                <Modal
                    closeTimeoutMS={500}
                    isOpen={messageModalStatus}
                    className="Modal"
                    overlayClassName="Overlay"
                    disableAutoFocus={true}>
                    {renderContent()}
                </Modal>
            </CSSTransition>
        </div>
    )
}

export default MessageModal